import * as React from 'react';

export interface INewsArchiveFilterProps {
    years: string[];
    selectedYear: string;
    selectedMonth: string;
    disabled?: boolean;
    onUpdate: (filterState: NewsArchiveFilterState) => void;
}

export type NewsArchiveFilterState = {
    year?: string;
    month?: string;
};

const months: string[] = [
    'Alla månader',
    'Januari',
    'Februari',
    'Mars',
    'April',
    'Maj',
    'Juni',
    'Juli',
    'Augusti',
    'September',
    'Oktober',
    'November',
    'December',
];

export const NewsArchiveFilter: React.FC<INewsArchiveFilterProps> = ({ years, selectedYear, selectedMonth, disabled, onUpdate }) => {
    const handleUpdate = (event: React.ChangeEvent<HTMLSelectElement>) => {
        onUpdate({ [event.target.name]: event.target.value });
    };

    return (
        <div className="d-flex news-archive news-archive__select-news-container mb-4">
            <div className="news-archive__select">
                <label htmlFor="news-archive-year-select" className="visually-hidden">
                    Välj år
                </label>
                <select id="news-archive-year-select" name="year" value={selectedYear} disabled={!!disabled} onChange={handleUpdate}>
                    {selectedYear &&
                        years.map((year: string, index: number): JSX.Element => (
                            <option key={`${year}-${index}`} value={year}>
                                {year}
                            </option>
                        ))}
                </select>
            </div>
            <div className="news-archive__select">
                <label htmlFor="news-archive-month-select" className="visually-hidden">
                    Välj månad
                </label>
                <select id="news-archive-month-select" name="month" value={selectedMonth} disabled={!!disabled} onChange={handleUpdate}>
                    {selectedYear &&
                        months.map((month: string, index: number): JSX.Element => (
                            <option key={`${month}-${index}`} value={index}>
                                {month}
                            </option>
                        ))}
                </select>
            </div>
        </div>
    );
};
